import { SVGProps } from 'react';
interface SVGRProps {
    title?: string;
    titleId?: string;
}
export const IconFileTypeJpg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 24 24"
        display="block"
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M7 4a1 1 0 0 0-1 1v7a1 1 0 1 1-2 0V5a3 3 0 0 1 3-3h7a1 1 0 0 1 .707.293l5 5A1 1 0 0 1 20 8v4a1 1 0 1 1-2 0V9h-3a2 2 0 0 1-2-2V4zm8 1.414L16.586 7H15zM4 15a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v4.5a2.5 2.5 0 0 1-5 0 1 1 0 1 1 2 0 .5.5 0 0 0 1 0V16H5a1 1 0 0 1-1-1m6 0a1 1 0 0 1 1-1h1.5a2.5 2.5 0 0 1 0 5H12v2a1 1 0 1 1-2 0zm2 2h.5a.5.5 0 0 0 0-1H12zm4.879-2.121A3 3 0 0 1 19 14h1a1 1 0 1 1 0 2h-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1v-2a1 1 0 1 1 2 0v3a1 1 0 0 1-1 1h-1a3 3 0 0 1-3-3v-2a3 3 0 0 1 .879-2.121"
            clipRule="evenodd"
        />
    </svg>
);
